<template>
  <el-tooltip placement="top" :disabled="!tooltip">
    <div slot="content" class="dm-chip__tip">
      <div>{{ platformName }} · {{ chip.text }}</div>
      <div v-if="chip.note">{{ chip.note }}</div>
      <div v-if="shopNote">{{ shopNote }}</div>
      <div v-if="driftFields">{{ $t('플랫폼과 다른 항목') }}: {{ driftFields }}</div>
      <div v-if="resultCode" class="dm-chip__code">{{ resultCode }}</div>
    </div>
    <el-tag
      :type="chip.tagType"
      size="mini"
      :class="['dm-chip', clickable ? 'dm-chip--clickable' : '']"
      @click.native="onClick">
      <span class="dm-chip__platform">{{ platformName }}</span>
      <span class="dm-chip__text">{{ chip.text }}</span>
      <i v-if="chip.resolve" class="el-icon-warning-outline"></i>
    </el-tag>
  </el-tooltip>
</template>

<script>
import { deliveryMenuChip, deliveryFieldLabel, deliveryMenuPlatformName, shopsNote } from '@/utils/deliveryMenuSync'

/**
 * 플랫폼 chip 하나. 문구·톤은 `deliveryMenuSync.deliveryMenuChip` 한 곳이 만든다(SSOT) —
 * 이 컴포넌트는 그 결과를 그리기만 한다.
 *
 * `resultMessage` 는 서버가 만든 추가 설명일 때만 값이 있고 파싱 대상이 아니다 (§16.57).
 */
export default {
  name: 'DeliveryMenuChip',

  props: {
    /** `DeliveryMenuPlatformStatus` */
    status: { type: Object, required: true },
    clickable: { type: Boolean, default: true },
    tooltip: { type: Boolean, default: true },
  },

  computed: {
    chip() {
      return deliveryMenuChip(this.status)
    },
    platformName() {
      return deliveryMenuPlatformName(this.status.platform)
    },
    shopNote() {
      const item = this.status.lastItem
      return item ? shopsNote(item.shops) : null
    },
    driftFields() {
      const drift = this.status.drift
      if (!drift || !drift.fields || drift.fields.length === 0) return null
      return drift.fields.map(deliveryFieldLabel).join(', ')
    },
    resultCode() {
      // 진단용이라 툴팁에만 둔다 — 문구는 status(와 SUPERSEDED 의 resultCode)가 이미 만들었다
      const item = this.status.lastItem
      return item && item.resultCode ? item.resultCode : null
    },
  },

  methods: {
    onClick() {
      if (!this.clickable) return
      this.$emit('select', { status: this.status, chip: this.chip })
    },
  },
}
</script>

<style scoped>
.dm-chip {
  margin: 1px 3px 1px 0;
}
.dm-chip--clickable {
  cursor: pointer;
}
.dm-chip__platform {
  font-weight: 600;
  margin-right: 4px;
}
.dm-chip__text {
  opacity: 0.9;
}
.dm-chip__tip {
  line-height: 1.6;
  max-width: 280px;
}
.dm-chip__code {
  opacity: 0.7;
  font-size: 11px;
}
</style>
